import axios from "axios";
import Moment from "moment";
import { extendMoment } from "moment-range";
import ApiStore from "./ApiStore";
const moment = extendMoment(Moment);

var querystring = require("querystring");

export class HrStore extends ApiStore {
  constructor() {
    super();
  }

  loadOrgList(completeFunc) {
    axios
      .get("/authen/orglist")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAuthenBypass() {
    axios
      .get("/authen/authen_bypass")
      .then(function (response) {
        console.log(response);
        //completeFunc(response.data)
        let data = response.data;
        //cookie.save('access_token', data.access_token , { path: '/'});
        //cookie.save('bf_org_id', data.bf_org_id , { path: '/' });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getPeriodic(year, month, between) {
    var d = new Date(year, month * 1, 0);
    var day = d.getDate();
    let res = between.split("-");
    day = res[1];
    let periodic = day + "/" + month + "/" + year;
    return periodic;
  }

  getCountOfWork(rangeValue) {
    let startDate = moment(rangeValue.startDate, "YYYY/MM/DD");
    let endDate = moment(rangeValue.endDate, "YYYY/MM/DD");

    const range = moment.range(startDate, endDate);

    const acc = Array.from(range.by("day", { exclusive: false }));

    let workAcc = acc.reduce((rresult, item) => {
      let dow = item.day();
      if (dow !== 0) rresult.push(item);
      return rresult;
    }, []);
    //console.log('countOfWork',workAcc)
    return workAcc.length;
  }

  checkJsonResult(responseText) {
    if (typeof responseText === "string") return false;
    return true;
  }

  loadContractorList(query, pageNo, completeFunc) {
    axios
      .get("/hr/employeelist?query=" + query + "&show_field=true&status=8")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadContractorSlipList(completeFunc, errorFunc) {
    axios
      .get("/employee/allslip_contractor")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc();
      });
  }

  loadMechanicList(query, pageNo, completeFunc) {
    axios
      .get(
        "/hr/employeelist?query=" + query + "&show_field=true&status=mechanic"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadEmployee(emStatus, completeFunc) {
    axios
      .get("/hr/employeelist?status=" + emStatus + "&show_field=true")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadEmployeeQuery(query, completeFunc) {
    axios
      .get("/hr/employeelist?query=" + query + "&show_field=true")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadEmployeeStatusQuery(query, status, completeFunc) {
    axios
      .get(
        "/hr/employeelist?query=" +
          query +
          "&status=" +
          status +
          "&show_field=true"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAllSlipSummary(year, month, range, completeFunc, errorFunc) {
    let periodic = this.getPeriodic(year, month, range.value);
    let that = this;
    axios
      .get(
        "/hr/report_slip_summary?periodic=" +
          periodic +
          "&between=" +
          range.value +
          "&start=" +
          range.startDate +
          "&end=" +
          range.endDate+
          "&year="+year+"&month="+month
      )
      .then(function (response) {
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadSlipInfo(slipId, completeFunc) {
    console.log("loadSlipInfo", slipId);
    axios
      .get("/employee/slip_info?slip_id=" + slipId)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAllSlipDailyWage(year, month, range, completeFunc, errorFunc) {
    let periodic = this.getPeriodic(year, month, range.value);
    let that = this;
    let resulttype =
      range.resulttype !== undefined ? range.resulttype : "index";
    axios
      .get(
        "/employee/allslip_dailywage?periodic=" +
          periodic +
          "&between=" +
          range.value +
          "&start=" +
          range.start +
          "&end=" +
          range.end +
          "&resulttype=" +
          resulttype+"&year="+year+"&month="+month
      )
      .then(function (response) {
        console.log("response", response);
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadAllSlipMonthlyWage(year, month, range, completeFunc, errorFunc) {
    let periodic = this.getPeriodic(year, month, range.value);
    let that = this;
    let resulttype =
      range.resulttype !== undefined ? range.resulttype : "index";
    axios
      .get(
        "/employee/allslip_monthlywage?periodic=" +
          periodic +
          "&between=" +
          range.value +
          "&start=" +
          range.start +
          "&end=" +
          range.end +
          "&resulttype=" +
          resulttype+"&year="+year+"&month="+month
      )
      .then(function (response) {
        console.log("response", response);
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadAllSlipContractor(year, month, range, completeFunc, errorFunc) {
    let periodic = this.getPeriodic(year, month, range.value);
    let that = this;
    axios
      .get(
        "/employee/allslip_contractor?periodic=" +
          periodic +
          "&between=" +
          range.value +
          "&start=" +
          range.start +
          "&end=" +
          range.end
      )
      .then(function (response) {
        console.log("response", response);
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadContractorSlipDetail(slipId, completeFunc, errorFunc) {
    let that = this;
    axios
      .get("/employee/slip_info?slip_id=" + slipId + "&is_detail=true")
      .then(function (response) {
        console.log("response", response);
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadContractorSlipDetailAll(slipId, completeFunc, errorFunc) {
    let that = this;
    axios
      .get("/employee/slip_info?slip_list=" + slipId)
      .then(function (response) {
        console.log("response", response);
        if (that.checkJsonResult(response.data)) completeFunc(response.data);
        else errorFunc({ status: "error", desc: response.data });
      })
      .catch(function (error) {
        console.log("error", error);
        errorFunc({ status: "error", desc: error.desc.data });
      });
  }

  loadHoliday(year, completeFunc, errorFunc) {
    year = year - 543;
    axios
      .get("/employee/holiday?year=" + year + "&format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadSlipConfig(completeFunc, errorFunc) {
    axios
      .get("/employee/slip_config?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadSsoConfig(completeFunc, errorFunc) {
    axios
      .get("/employee/sso_config")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadBenefitOptions(type, input) {
    return axios.get(
      "/employee/benefit_options?format=json&q=" + input + "&type=" + type
    );
  }

  loadConfigHrTable(type, completeFunc, errorFunc) {
    axios
      .get("/employee/config_hr_table?format=json" + "&type=" + type)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadSlipConfigPeriodParams(params, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/slip_config?format=json&year=" +
          (params.year - 543) +
          "&month=" +
          params.month +
          "&em_type=" +
          params.em_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadSlipConfigPeriod(year, month, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/slip_config?format=json&year=" +
          (year - 543) +
          "&month=" +
          month
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadAbsenceOnPeriod(emId, start, end, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/absenceonperiod/" +
          emId +
          "?start=" +
          start +
          "&end=" +
          end +
          "&format=json"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadDeductionOnPeriod(emId, start, end, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/deductiononperiod/" +
          emId +
          "?start=" +
          start +
          "&end=" +
          end +
          "&format=json"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadContractorWageDetail(contractorId, completeFunc, errorFunc) {
    axios
      .get("/hr/report_contractor_wage_detail/" + contractorId + "?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadReportAdvanceSalary(year, month, day, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/advancesalary/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&format=json"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadEmployeeAllabsence(year, month, completeFunc, errorFunc) {
    axios
      .get(
        "/employee/allabsence/?year=" +
          year +
          "&month=" +
          month +
          "&format=json"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadReportOT(year, month, completeFunc, errorFunc) {
    axios
      .get("/hr/report_ot/?year=" + year + "&month=" + month + "&format=json2")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadReportAbsence(year, month, completeFunc, errorFunc) {
    axios
      .get(
        "/hr/report_absence/?year=" + year + "&month=" + month + "&format=json2"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadReportAbsenceDeduction(year, month, completeFunc, errorFunc) {
    axios
      .get(
        "/hr/report_absence_deduction/?year=" +
          year +
          "&month=" +
          month +
          "&format=json2"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  newAdvanceSalary(year, month, day, param, completeFunc, errorFunc) {
    let postData = { year: year, month: month, day: day };
    postData = Object.assign(postData, param);
    console.log("newAdvanceSalary", postData);
    axios
      .post(
        "/employee/newadvancesalary?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day,
        querystring.stringify(postData)
      )
      .then(function (response) {
        console.log(response);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  editSlipDailyWage(param, completeFunc, errorFunc) {
    let postData = param;
    console.log("editSlipDailyWage", postData);
    axios
      .post("/employee/editsliptable_dailywage", postData)
      .then(function (response) {
        console.log(response);
        let result = response.data;
        if (result.status == "OK") completeFunc();
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  newSlipDailyWage(year, month, rangeValue, options, completeFunc, errorFunc) {
    let that = this;
    var newSlipTable = function () {
      let promise = new Promise(function (resolve, reject) {
        //Get root concept
        let periodic = that.getPeriodic(year, month, rangeValue.value);
        let first_periodic = that.getPeriodic(year, month, options[0].value);
        let countOfWork = that.getCountOfWork(rangeValue);
        let postData = {
          year:year,
          month:month,          
          periodic: periodic,
          first_start_date: options[0].startDate,
          first_periodic: first_periodic,
          seq_in_month: rangeValue.seqInMonth,
          start_date: rangeValue.startDate,
          end_date: rangeValue.endDate,
          count_office_work: countOfWork,
        };
        console.log("newSlipPost", postData);
        axios
          .post(
            "/employee/newsliptable_dailywage",
            querystring.stringify(postData)
          )
          .then(function (response) {
            console.log(response);
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
      return promise;
    };

    var loadAllSlip = function (result) {
      if (result.status === "OK")
        that.loadAllSlipDailyWage(
          year,
          month,
          rangeValue,
          completeFunc,
          errorFunc
        );
      else errorFunc(result);
    };

    newSlipTable()
      .then(loadAllSlip)
      .catch((error) => {
        console.log("error:", error);
        errorFunc({ status: "error", desc: error });
      });
  }

  newSlipMonthlyWage(
    year,
    month,
    rangeValue,
    options,
    completeFunc,
    errorFunc
  ) {
    let that = this;
    var newSlipTable = function () {
      let promise = new Promise(function (resolve, reject) {
        //Get root concept
        let periodic = that.getPeriodic(year, month, rangeValue.value);
        let first_periodic = that.getPeriodic(year, month, options[0].value);
        let countOfWork = that.getCountOfWork(rangeValue);
        let postData = {
          year:year,
          month:month,
          periodic: periodic,
          first_start_date: options[0].startDate,
          first_periodic: first_periodic,
          seq_in_month: rangeValue.seqInMonth,
          start_date: rangeValue.startDate,
          end_date: rangeValue.endDate,
          count_office_work: countOfWork,
        };
        axios
          .post(
            "/employee/newsliptable_monthlywage",
            querystring.stringify(postData)
          )
          .then(function (response) {
            console.log(response);
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
      return promise;
    };

    var loadAllSlip = function (result) {
      if (result.status === "OK")
        that.loadAllSlipMonthlyWage(
          year,
          month,
          rangeValue,
          completeFunc,
          errorFunc
        );
      else errorFunc(result);
    };

    newSlipTable()
      .then(loadAllSlip)
      .catch((error) => {
        console.log("error:", error);
        errorFunc({ status: "error", desc: error });
      });
  }

  newSlipContractor(year, month, rangeValue, options, completeFunc, errorFunc) {
    let that = this;
    var newSlipTable = function () {
      let promise = new Promise(function (resolve, reject) {
        //Get root concept
        let periodic = that.getPeriodic(year, month, rangeValue.value);
        let first_periodic = that.getPeriodic(year, month, options[0].value);
        let countOfWork = that.getCountOfWork(rangeValue);
        let postData = {
          periodic: periodic,
          first_periodic: first_periodic,
          seq_in_month: rangeValue.seqInMonth,
          start_date: rangeValue.startDate,
          end_date: rangeValue.endDate,
          count_office_work: countOfWork,
        };
        console.log("postData", postData);
        axios
          .post(
            "/employee/newsliptable_contractor",
            querystring.stringify(postData)
          )
          .then(function (response) {
            console.log(response);
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
      return promise;
    };

    var loadAllSlip = function (result) {
      if (result.status === "OK")
        that.loadAllSlipContractor(
          year,
          month,
          rangeValue,
          completeFunc,
          errorFunc
        );
      else errorFunc(result);
    };

    newSlipTable()
      .then(loadAllSlip)
      .catch((error) => {
        console.log("error:", error);
        errorFunc({ status: "error", desc: error });
      });
  }

  deleteAbsence(emId, absenceId, completeFunc, errorFunc) {
    let postData = { em: emId, bid: absenceId };
    console.log("postData", postData);
    axios
      .post("/employee/remove_absencerecord", querystring.stringify(postData))
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  saveSlipInfo(slipId, slipInfo, completeFunc) {
    let postData = { slip_id: slipId, data: slipInfo };
    console.log("postData", postData);
    axios
      .post("/employee/slip_info", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveConfigHrTable(type, postData, completeFunc) {
    //console.log('postData',postData)
    axios
      .post("/employee/config_hr_table?type=" + type, postData)
      .then(function (response) {
        //console.log('response',response.data)
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveAbsence(emId, absencerec, completeFunc, errorFunc) {
    let postData = { em: emId, absencerec: absencerec };
    console.log("postData", postData);
    axios
      .post("/employee/absencerecord", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  saveAdvanceSalary(postData, completeFunc, errorFunc) {
    console.log("postData", postData);
    axios
      .post("/employee/advancesalary", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  saveSlipConfig(slipConfig, completeFunc) {
    let postData = slipConfig;
    console.log("postData", postData);
    axios
      .post("/employee/slip_config", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveSsoConfig(ssoConfig, completeFunc) {
    let postData = ssoConfig;
    console.log("postData", postData);
    axios
      .post("/employee/sso_config", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveHoliday(year, tableList, completeFunc, errorFunc) {
    let postData = {
      year: year - 543,
      holiday: tableList.map((item, index) => {
        return [item.display_date, item.remark];
      }),
    };

    console.log("postData", postData);
    axios
      .post("/employee/holiday", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  saveSlipPeriod(periodic, year, month, rangeValue, completeFunc, errorFunc) {
    let postData = {
      periodic: periodic,
      year: year - 543,
      month: month,
      range: rangeValue,
    };
    console.log("postData", postData);
    axios
      .post("/employee/slip_period", postData)
      .then(function (response) {
        console.log("response", response.data);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  saveContractor(postData, completeFunc, errorFunc) {
    console.log("postData", postData);
    axios
      .post("/hr/contractor/", querystring.stringify(postData))
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  saveSlipContractorWithdraw(slipId, slip, completeFunc, errorFunc) {
    let that = this;

    //Get root concept
    let postData = { slip_id: slipId, slip: slip };

    axios
      .post("/employee/contractor_withdraw?slip_id=" + slipId, postData)
      .then(function (response) {
        console.log(response);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  delContractor(customerId, completeFunc, errorFunc) {
    console.log("customerId", customerId);
    axios
      .delete("/hr/contractor/" + customerId)
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  deleteContractorWithdraw(postData, completeFunc, errorFunc) {
    console.log("postData", postData);
    axios
      .post("/employee/delete_contractor_withdraw/", postData)
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  loadMechanicWorkMonthlyStat(year, month, em, completeFunc, errorFunc) {
    year = year - 543;
    axios
      .get(
        "/employee/mechanic_work_monthly_stat?year=" +
          year +
          "&month=" +
          month +
          "&em=" +
          em
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc();
      });
  }

  loadConfigEmployeeReportTable(completeFunc, errorFunc) {
    axios
      .get("/employee/config_employee_report_table")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc();
      });
  }

  saveConfigEmployeeReportTable(postData, completeFunc, errorFunc) {
    axios
      .post("/employee/config_employee_report_table/", postData)
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status == "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  loadSSOList(completeFunc) {
    axios
      .get("/employee/report_sso")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadEmployeeSSO(status, completeFunc, branchList, departmentList) {
    axios
      .get(
        "/employee/employee_sso?status=" +
          status +
          "&branch_list=" +
          branchList +
          "&department_list=" +
          departmentList
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadSsoConfig(completeFunc) {
    axios
      .get("/employee/hr_config")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default new HrStore();



// WEBPACK FOOTER //
// ./src/stores/HrStore.js